export var widthsMapping = {
  full: '100%',
  'fit-content': 'fit-content',
  'min-content': 'min-content',
  auto: 'auto'
};
export var heightsMapping = {
  full: '100%',
  'fit-content': 'fit-content',
  'min-content': 'min-content',
  auto: 'auto'
};
//# sourceMappingURL=utils.js.map